import * as React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { FaArrowRight } from "react-icons/fa";

const StyledContainer = styled(Container)`
  .btn:hover > a {
    color: #fff !important;
  }

  p {
    letter-spacing: 0.2px;
  }

  @media only screen and (max-width: 600px) {
    .link-mob {
      text-align: center;
    }
  }
`;

function EmailFinderMob() {
  return (
    <StyledContainer>
      <div className="row pt-4">
        <div className="col-sm-6 mb-2">
          <h2>Email Finder</h2>
          <i>Capture email addresses with just a name!</i>
          <ul className="text-left">
            <li className="py-3 fa fa-circle">
                The Email Finder offers multiple search options like domain
                search, company name search, and name plus domain search, giving
                you more control.
            </li>
            <li className="fa fa-circle">
                The API integration seamlessly fits into your workflow, allowing
                you to find emails individually or in bulk.
            </li>
            <li className="py-3 fa fa-circle">
                With the confidence scoring system, you get the most accurate
                and up-to-date email addresses, leading to effective email
                marketing campaigns and business growth.
            </li>
            <li className="fa fa-circle">
                Trust our email finder to elevate your lead generation efforts
                and take your business to the next level.
            </li>
          </ul>
          <div className="align-center">
            <Link to="/email-finder" aria-label="Explore Email Finder" className="btn btn-outline-dark px-3">
              Explore <FaArrowRight />
            </Link>
          </div>
        </div>
        <div className="col-sm-6">
          <StaticImage
            src="../../images/clearout_email_finder_update.png"
            className="mw-100"
            alt="Clearout's Email Finder to find email addresses for building your B2B Database"
          />
        </div>
      </div>
    </StyledContainer>
  );
}

export default EmailFinderMob;
